import { authGet } from '../utils/request';

const getSupplierApiLogs = (params = {}) => authGet('/logs/suppliers', { params })
  .then(({ data }) => data);

export default getSupplierApiLogs;
